module.exports = __webpack_public_path__ + "static/screen-esami-dark-b4b7fd44a79b89a3786f0940d0708f9e.png";